/**
 * Drop the demographics a backend identifier appends to the name ("Sarah
 * Mitchell, F, 41", "Ann Mitchell, Female, 41", "Ann Mitchell, 41"). Only a
 * gender word or a digit after the comma counts, so "Mitchell, Ann" survives.
 */
const DEMOGRAPHIC_SUFFIX = /^(.+?),\s*(?:(?:m|f|x|male|female|other|unknown)\b|\d)/iu;

export const patientNameWithoutDemographics = (name: string): string =>
  (name.match(DEMOGRAPHIC_SUFFIX)?.[1] ?? name).trim();

/** Compares two names for the same patient, whatever demographics either carries. */
export const patientNameKey = (name: string): string =>
  patientNameWithoutDemographics(name).toLowerCase();
